import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CryptoJS from 'crypto-js';
import { loginSuccess } from '../store/userSlice';
import { PW_Login_API } from '../Server/ApiV2';

const ENC_KEY = 'PW-S3CR3T-K3Y-2026-X9Z';
// Remember me keeps only the User ID in this browser. The password is left to
// the browser's own password manager (the fields carry autocomplete hints) and is
// never stored by the page; the old password key is cleared on load.
const LS_USER = 'lottery.rememberedUser';
const LS_PASS = 'lottery.rememberedPass';

export default function Login() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState(() => localStorage.getItem(LS_USER) || '');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(() => !!localStorage.getItem(LS_USER));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem(LS_PASS);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const encPassword = CryptoJS.AES.encrypt(password, ENC_KEY).toString();
      const res = await PW_Login_API({ username, password: encPassword });
      if (res?.data?.success) {
        const d = res.data.data;
        if (remember) localStorage.setItem(LS_USER, username);
        else localStorage.removeItem(LS_USER);
        dispatch(loginSuccess({
          user: d.user,
          roleId: d.roleId,
          roleName: d.roleName,
          assignedStores: d.assignedStores,
        }));
      } else {
        setError(res?.data?.message || res?.response?.data?.message || 'Invalid username or password');
      }
    } catch (err) {
      setError('Unable to connect to server');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-float login-float-1" />
      <div className="login-float login-float-2" />
      <div className="login-float login-float-3" />
      <div className="login-card">
        <div className="login-logo">
          <div>
            <div className="login-logo-text">Good Find</div>
            <div className="login-logo-sub">Instant Rewards</div>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}
          <div className="login-field">
            <label>User ID</label>
            <input
              type="text" name="username" autoComplete="username" value={username} placeholder="Enter username"
              onChange={(e) => setUsername(e.target.value)} autoFocus={!remember}
            />
          </div>
          <div className="login-field">
            <label>Password</label>
            <div className="login-password-wrap">
              <input
                type={showPass ? 'text' : 'password'} name="password" autoComplete="current-password"
                value={password} placeholder="Enter password"
                onChange={(e) => setPassword(e.target.value)} autoFocus={remember}
              />
              <button type="button" className="login-password-toggle"
                onClick={() => setShowPass(!showPass)}>
                {showPass ? '◉' : '◎'}
              </button>
            </div>
          </div>
          <label className="login-remember">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            Remember me
          </label>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <div className="login-footer">
          <span>2026 Good Find</span>
        </div>
      </div>
    </div>
  );
}
